module.exports = __webpack_public_path__ + "static/ervin-hiking-516400b3db8f8f86e345cc80594461e3.jpg";